import { Injectable } from '@angular/core';
import { FileItem } from 'ng2-file-upload';

import { StorageAPIService } from '../storage-api.service';

export interface Lookup {
  id: string;
  displayName: string;
  userId: string;
  values: string[];
  createdAt: Date;
  modifiedAt: Date;
}

@Injectable()
export class LookupService extends StorageAPIService {
  createLookup(name: string, fileItem: FileItem) {
    fileItem.url = `${this.getBaseUrl()}/lookup`;
    fileItem.onBuildForm = (form) => {
      form.append('displayName', name);
    };
    fileItem.upload();
  }

  getLookup(id: string): Promise<Lookup> {
    return this.get(`/lookup/${id}`);
  }

  updateLookup(lookup: Lookup): Promise<Lookup> {
    return this.put(`/lookup/${lookup.id}`, { displayName: lookup.displayName });
  }

  deleteLookup(id: string): Promise<void> {
    return this.delete(`/lookup/${id}`);
  }
}
